require('../bootstrap');

import $ from 'jquery';
import Vue from 'vue';
import VueNoty from 'vuejs-noty';
import i18n from './i18n';
import VuePlyr from 'vue-plyr'


import axios from 'axios';

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {

  const islogin = error.response.config.url ? /api\/apps\/login/.test(error.response.config.url) : false

  if (!islogin && error.response.status === 401) {
    window.location.href = '/apps/login';
  }
  return Promise.reject(error)
})



import VueZoomer from 'vue-zoomer'
Vue.use(VueZoomer)

import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

import { mapActions, mapGetters, mapState } from 'vuex'

Vue.use(VueNoty, {
  progressBar: false,
  layout: 'bottomRight',
  theme: 'bootstrap-v4',
  timeout: 3000
});

// Vue Plyr Player
Vue.use(VuePlyr)


import VueHead from 'vue-head';
Vue.use(VueHead)

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox)

import router from './router';
import store from './store/index';
import App from './components/App.vue';

import VueAnalytics from 'vue-analytics';
// Vue Analytics
Vue.use(VueAnalytics, {
  id: 'G-1KR9YF5445',
  router
})

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  duration: 1000,
  easing: "ease"
})

import VueFlashMessage from '@smartweb/vue-flash-message'
Vue.use(VueFlashMessage)


Vue.component('app', App);

const app = new Vue({
  router,
  i18n,
  store,
  computed: {
    ...mapState({
      loading: 'loading',
      language: state => state.language.lang
    }),
    ...mapGetters({
      isLoading: 'isLoading'
    })
  },
  watch: {
    language:{
      handler (newLanguage, oldLanguage) {
        this.$i18n.locale = newLanguage
      }
    }
  },
  methods: {
    ...mapActions([
      'selectLanguage',
    ]),
  }
}).$mount('#app');
